import {
  BookingStepBaseTestIDMap,
  BookingStepTitleMap,
} from "@/constants/Booking";
import BookingTitleHeader from "@/ui/components/schedule/booking/BookingTitleHeader";

interface BookingStepTitleProps {
  step: BookingStep;
}

const BookingStepTitle = ({ step }: BookingStepTitleProps) => {
  const title = BookingStepTitleMap[step];
  const baseTestID = BookingStepBaseTestIDMap[step];

  return <BookingTitleHeader testID={baseTestID} title={title} />;
};

export default BookingStepTitle;
